import List from './List.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'list', List);
  },
};
